import {view} from '@sail/ui/deprecated';
import {Link} from '@sail/ui';
import {ConversationLogItemMetaEvent} from '@stripe-internal/conversations-client';
import {FormattedMessage} from 'react-intl';
import {ReactNode} from 'react';
import {MetaRow} from '../../Chat';

const LLM_DISCLAIMER_ID = 'llm-disclaimer';
const AI_LINK_URL =
  'https://support.stripe.com/questions/use-of-artificial-intelligence-%28ai%29-in-stripe-services';
const PRIVACY_LINK_URL = 'https://stripe.com/privacy';

const llmDisclaimerValues = {
  aiLink: (chunks: ReactNode) => (
    <Link href={AI_LINK_URL} target="_blank">
      {chunks}
    </Link>
  ),
  privacyLink: (chunks: ReactNode) => (
    <Link href={PRIVACY_LINK_URL} target="_blank">
      {chunks}
    </Link>
  ),
  br: <br />,
};

export const MetaEventRow = ({item}: {item: ConversationLogItemMetaEvent}) => {
  const values =
    item.id === LLM_DISCLAIMER_ID ? llmDisclaimerValues : item.values;

  return (
    <view.div
      data-testid="conversation-meta-event"
      className="uh-conversations-contains-meta-row"
    >
      <MetaRow style={item.style}>
        <FormattedMessage {...item.message} values={values} />
      </MetaRow>
    </view.div>
  );
};
